import addAgendaItemsWithMutation from '../utils/addAgendaItemsWithMutation';
import getStore from '../store/store';
import trimAgendaItems from '../utils/trimAgendaItems';
import { AgendaItem } from 'mini-agenda';
import { mutatorAction } from 'satcheljs';

export const MAX_AGENDA_ITEMS: number = 200;

/**
 * Mutator which adds agenda items a given end and
 * deletes items from other end if the total count exceeds max limit of 250.
 */
const addAgendaItemsMutator = mutatorAction(
    'addAgendaItemsMutator',
    (agendaItems: AgendaItem[], shouldAddToTop: boolean) => {
        const agendaStore = getStore();
        if (!agendaStore.items) {
            agendaStore.items = [] as AgendaItem[];
        }
        addAgendaItemsWithMutation(agendaStore.items, agendaItems, shouldAddToTop);
        // If the agenda items count is more than permitted limit, remove agenda items from the other end.
        agendaStore.items.length > MAX_AGENDA_ITEMS &&
            trimAgendaItems(
                agendaStore.items,
                agendaStore.items.length - MAX_AGENDA_ITEMS,
                !shouldAddToTop
            );
    }
);

export default addAgendaItemsMutator;
